import { useToast } from '@chakra-ui/react';
import { useUpdatePropertyDetailsMutation } from '@client/graphql/__generated__/main-operations';
import isNil from 'lodash/isNil';
import { useState } from 'react';
import { EditOffMarketListingFormData } from '../AddOffMarketListing/constants';

interface UseEditOffMarketListingActionsProps {
  onClose: () => void;
  onSave: () => void;
}

export const useEditOffMarketListingActions = ({
  onClose,
  onSave,
}: UseEditOffMarketListingActionsProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [updatePropertyDetails] = useUpdatePropertyDetailsMutation();
  const toast = useToast();

  const handleSubmit = async (
    propertyDetailsId: string,
    values: EditOffMarketListingFormData
  ) => {
    try {
      setIsLoading(true);

      const convertNumberValue = (value: number) =>
        !isNil(value) ? Number(value) : value;

      await updatePropertyDetails({
        variables: {
          input: {
            propertyDetailsId,
            targetPrice: convertNumberValue(values.targetPrice),
            areaSqFt: convertNumberValue(values.squareFootage),
            yearBuilt: convertNumberValue(values.yearBuilt),
            bedrooms: convertNumberValue(values.bedrooms),
            bathsFull: convertNumberValue(values.fullBaths),
            bathsHalf: convertNumberValue(values.halfBaths),
            propertyType: values.propertyType,
            propertySubtype: values.propertySubtype,
            subdivision: values.subdivision || '',
            schoolDistrict: values.schoolDistrict || '',
          },
        },
      });

      onSave();
      onClose();

      toast({
        title: 'Off-market listing updated',
        status: 'success',
      });
    } catch (error) {
      toast({
        title: 'Error updating off-market listing',
        description: 'Please try again later',
        status: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleSubmit,
    isLoading,
  };
};
